import * as CL from '@design-system/component-library';
import { generatePath, useNavigate } from 'react-router';
import { paths } from '../../../common/constants/pathVariables';
import { useSearchParams } from '../../../common/hooks/useSearchParams';
import type { Contact } from '../../../generated/api/contact';

export const ContactUpdateLink = ({
  text,
  redirectMessage,
  contact,
}: {
  text: string;
  redirectMessage: string;
  contact?: Contact;
}) => {
  const navigate = useNavigate();
  const mdmId = useSearchParams<{ mdmId: string }>().mdmId!;

  return (
    <CL.Link
      onClick={() => {
        if (contact?.contactMasterId) {
          const path = `${generatePath(paths.COMPANY_INFO_CONTACT, { contactMasterId: contact.contactMasterId })}?mdmId=${mdmId}`;
          navigate(path, { state: { redirectToPath: `${location.pathname}?mdmId=${mdmId}`, redirectMessage } });
        }
      }}
    >
      {text}
      <CL.Icon icon="edit" />
    </CL.Link>
  );
};
